import { render, staticRenderFns } from "./AddonPixel.vue?vue&type=template&id=0f5ef678&scoped=true&"
import script from "./AddonPixel.vue?vue&type=script&lang=js&"
export * from "./AddonPixel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5ef678",
  null
  
)

export default component.exports